/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/WhatsappBubblePosition.js
class WhatsappBubblePosition {
  constructor() {
    this.bubble = document.querySelector('#carthike-chat-button-container');
    this.stickyCart = document.querySelector('sticky-cart');
    this.backToTop = document.querySelector('back-to-top');

    const bubbleComputedStyle = this.bubble
      ? window.getComputedStyle(this.bubble)
      : null;
    this.bottomBase = bubbleComputedStyle
      ? parseInt(bubbleComputedStyle.bottom, 10) || 0
      : 0;
    this.gap = 4;
  }

  init = () => {
    if (!this.bubble) return;

    const observer = new MutationObserver(() => this.updateLayout());
    const config = { attributes: true, attributeFilter: ['class'] };

    if (this.stickyCart) observer.observe(this.stickyCart, config);
    if (this.backToTop) observer.observe(this.backToTop, config);

    this.updateLayout();
  };

  updateLayout = () => {
    let extraOffset = 0;
    let visibleElementsCount = 0;
    let finalGap = 0;

    if (this.stickyCart && this.stickyCart.classList.contains('open')) {
      extraOffset += this.stickyCart.offsetHeight;
      visibleElementsCount++;
      finalGap += this.gap;
    }

    if (this.backToTop && this.backToTop.classList.contains('open')) {
      if (visibleElementsCount > 0) extraOffset += this.gap;

      extraOffset += this.backToTop.offsetHeight;
      visibleElementsCount++;
      finalGap += this.gap;
    }

    const finalBottom = this.bottomBase + extraOffset + finalGap;

    this.bubble.style.transition = 'bottom 0.3s ease-in-out';
    this.bubble.style.bottom = `${finalBottom}px`;
  };
}

;// ./src/js/FooterAxeptio.js
class FooterAxeptio {
  constructor() {
    this.footerLinksSelector = '.footer .list-menu__item--link';
  }

  init = () => {
    const footerLinks = document.querySelectorAll(this.footerLinksSelector);

    if (!footerLinks.length > 0) {
      return;
    }
    footerLinks.forEach((link) => {
      if (link.href.includes('#replaceAxeptio')) {
        // eslint-disable-next-line no-script-url
        link.href = 'javascript:openAxeptioCookies()';
        return;
      }
    });
  };
}

;// ./src/main.js


// JS goes here


window.addEventListener('load', () => {
  const classes = [new FooterAxeptio(), new WhatsappBubblePosition()];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;